import { memoizedGet as get } from './object'
import {
  getStepSize,
  resolveSize,
  themeFontIndexToFontSize as themeFontSizeIndexToFontSize
} from './size-utils'
import type { SizeProps } from '../components/_primitives/types'
import type { Theme } from '../theme-provider/types'

export default function (
  size: SizeProps,
  theme: Theme,
  stepIconSize = 0,
  stepSpinnerSize = 0
): {
  fontSize: string | string[]
  spinnerSize: SizeProps
  iconSize: SizeProps
} {
  return {
    fontSize: themeFontSizeIndexToFontSize(
      theme,
      resolveSize(size, get(theme, 'sizes.font'))
    ),
    spinnerSize: getStepSize(size, stepSpinnerSize),
    iconSize: getStepSize(size, stepIconSize)
  }
}
